import { render, staticRenderFns } from "./MandatSepaComponenet.vue?vue&type=template&id=d133e0c4&"
import script from "./MandatSepaComponenet.vue?vue&type=script&lang=js&"
export * from "./MandatSepaComponenet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports